/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, creator: NonNullable<unknown> }} Agent_Access_Hidden_Knowledge_PluralInputs */



/**
* | output |
* | --- |
* | "{count} spaces you can't see: ask {creator}." |
*
* @param {Agent_Access_Hidden_Knowledge_PluralInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_access_hidden_knowledge_plural = /** @type {((inputs: Agent_Access_Hidden_Knowledge_PluralInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Access_Hidden_Knowledge_PluralInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Bereiche, die Sie nicht sehen können: Fragen Sie ${i?.creator}.`)
	return /** @type {LocalizedString} */ (`${i?.count} spaces you can't see: ask ${i?.creator}.`)
});